<template>
    <div :class="$style.modal"/>
</template>

<script>
export default {

}
</script>

<style module>
.modal{
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100vh;
    background-color: #262626;
    opacity: 0.8;
}
</style>